








































import { defineComponent, ref } from '@nuxtjs/composition-api';

export default defineComponent({
  props: {
    price: {
      type: Number,
      default: 0,
    },
    lineThroughPrice: {
      type: Number,
      default: 0,
    },
    year: {
      type: String,
      default: '',
    },
    fontSize: {
      type: String,
      default: 'text-5xl',
    },
    isRed: {
      type: Boolean,
      default: false,
    },
    excludingTaxPrice: {
      type: Number,
      default: 0,
    },
    hideTaxIncluded: {
      type: Boolean,
      default: false,
    },
    showTaxExcluded: {
      type: Boolean,
      default: false,
    },
    discountRate: {
      type: Number,
      default: 0,
    },
    hasMultiPrice: {
      type: Boolean,
      default: false,
    },
    shouldJustifyEnd: {
      type: Boolean,
      default: false,
    },
    isPriceBold: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    // 円のフォントサイズ
    const yenSize = ref('text-base');
    // 横線金額のサイズ
    const lineThroughSize = ref('text-xl');

    switch (props.fontSize) {
      case 'text-3xl':
      case 'text-xl':
      case 'text-base':
      case 'text-sm':
        yenSize.value = 'text-2xs';
        lineThroughSize.value = 'text-xs';
        break;
    }

    return { yenSize, lineThroughSize };
  },
});
